import React from 'react';
import PropTypes from 'prop-types';
import FiltersGroup from './FiltersGroup';

import './style.scss';

const FiltersContainer = ({
  filters,
  selectedFilters,
  setFilters,
  onSelectChange,
}) => (
  <div className="filters-container">
    {Object.keys(filters).length ? Object.keys(filters).sort((a, b) => a > b).map((key, i) =>
      <FiltersGroup
        selectedFilters={selectedFilters}
        setFilters={setFilters}
        onSelectChange={onSelectChange}
        key={key}
        withoutHr={i === Object.keys(filters).length - 1}
        filterGroup={filters[key]}
      />) : null}
  </div>
);

FiltersContainer.propTypes = {
  filters: PropTypes.object.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
};

export default FiltersContainer;



// WEBPACK FOOTER //
// ./src/components/ui/FiltersContainer/index.js